import { FC } from 'react';

type Props = {
  jsonLD: Object;
};

export const JsonLD: FC<Props> = ({ jsonLD }) => (
  <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLD) }} />
);
